import { keyframes, SxProps, Typography } from "@mui/material";

const fade = keyframes({
    from: {
        opacity: 0.25,
    },
    to: {
        opacity: 1,
    },
});

const styles: SxProps = {
    fontWeight: 600,
    letterSpacing: "-0.05rem",
    ".EllipsisProgress-a": {
        animation: `1s ${fade} 0s ease infinite alternate-reverse`,
    },
    ".EllipsisProgress-b": {
        animation: `1s ${fade} 0.25s ease infinite alternate-reverse`,
    },
    ".EllipsisProgress-c": {
        animation: `1s ${fade} 0.5s ease infinite alternate-reverse`,
    },
};

export default function EllipsisProgress() {
    return (
        <Typography className="EllipsisProgress" component="span" sx={styles}>
            <span className="EllipsisProgress-a">.</span>
            <span className="EllipsisProgress-b">.</span>
            <span className="EllipsisProgress-c">.</span>
        </Typography>
    );
}
